// @ts-nocheck
import accountReducer, { StoreAccountActions } from "@store/Framework/Store/Store/Data/Accounts/AccountReducer";
import { combineReducers } from "redux";

const dataReducers = {
    account: accountReducer,
};

export type StoreDataActions = StoreAccountActions;
export default combineReducers(dataReducers);
